export function authHeader() {
    
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

export function postHeader() {
    return { 'X-Requested-With': 'XMLHttpRequest'};
}